<template>
  <div
    :class="[
      $style.box_wrapper,
      isDisable ? $style.disable : null,
      'vgp-interactive-element'
    ]"
  >
    <label :class="$style.checkbox">
      <span
        v-if="showLabelLeft"
        :class="labelWrapperClass"
        :style="labelStyleLeft"
      >
        <slot
          v-if="hasLabelSlot"
          name="label"
        />
        <template v-else>{{ label }}</template>
      </span>

      <span :class="$style.check_hit_area">
        <input
          :class="$style.check_input"
          type="checkbox"
          :checked="checked"
          :disabled="isDisable"
          @change="$emit('update:checked', !!$event.target.checked)"
          @click="onClick"
        >
        <span
          :class="[
            $style.check_box,
            isError ? $style.check_box_error : '',
            isDisable && checked ? $style.check_box_disabled_checked : '',
          ]"
          :style="checkBoxMetrics"
        >
          <svg
            v-if="checked"
            :class="$style.check_inner"
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="8"
            viewBox="0 0 11 8"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11 0.841163L3.45714 8L0 4.71887L0.886286 3.8777L3.45714 6.31171L10.1137 0L11 0.841163Z"
              fill="#FFFFFF"
            />
          </svg>
        </span>
      </span>

      <span
        v-if="showLabelRight"
        :class="labelWrapperClass"
        :style="labelStyleRight"
      >
        <slot
          v-if="hasLabelSlot"
          name="label"
        />
        <template v-else>{{ label }}</template>
      </span>
    </label>
  </div>
</template>

<script>
function toCssLength(value) {
  if (value == null || value === '') {
    return null;
  }

  return typeof value === 'number' ? `${value}px` : value;
}

export default {
  name: 'VGpCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 16,
    },
    label: {
      type: String,
      default: null,
    },
    labelClass: {
      type: [String, Object, Array],
      default: null,
    },
    labelLineHeight: {
      type: [String, Number],
      default: 18,
    },
    labelHeight: {
      type: [String, Number],
      default: 14,
    },
    labelPosition: {
      type: String, // left or right
      default: null,
    },
    color: {
      type: String,
      default: '#1565C0',
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    onClick: null,
    'update:checked': null,
  },
  computed: {
    hasLabelSlot() {
      return Boolean(this.$slots.label);
    },
    hasLabel() {
      return this.hasLabelSlot || Boolean(this.label);
    },
    showLabelLeft() {
      return this.hasLabel && this.labelPosition === 'left';
    },
    showLabelRight() {
      return this.hasLabel && this.labelPosition === 'right';
    },
    labelWrapperClass() {
      const base = this.hasLabelSlot ? this.$style.label_slot : this.$style.label_text;

      return this.labelClass ? [base, this.labelClass] : base;
    },
    labelTypographyStyle() {
      const style = {};
      const lh = toCssLength(this.labelLineHeight);
      const h = toCssLength(this.labelHeight);

      if (lh != null) {
        style.lineHeight = lh;
      }

      if (h != null) {
        style.height = h;
      }

      return style;
    },
    labelStyleLeft() {
      return { marginRight: '8px', ...this.labelTypographyStyle };
    },
    labelStyleRight() {
      return { marginLeft: '8px', ...this.labelTypographyStyle };
    },
    checkBoxMetrics() {
      const s = `${this.size}px`;
      const base = {
        width: s,
        height: s,
        minWidth: s,
      };

      if (this.checked && !this.isDisable) {
        return {
          ...base,
          backgroundColor: this.color,
          borderColor: this.color,
        };
      }

      return base;
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    },
  },
};
</script>

<style module lang="less" src="./checkbox.less"></style>
